import React, { useEffect, useState } from "react";
import { Input, Button, Table, Spacer } from "@nextui-org/react";
import { Box, Typography } from "@mui/material";
import { db } from "../../firebaseConfig"; // Assuming you have your firebase config set up
import { collection, getDocs } from "firebase/firestore";
import "./ActivityAuditPage.css";

const ActivityAuditPage = () => {
  const [activities, setActivities] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredActivities, setFilteredActivities] = useState([]);

  useEffect(() => {
    const fetchActivities = async () => {
      try {
        const snapshot = await getDocs(collection(db, "activity_logs"));
        const activitiesData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setActivities(activitiesData);
      } catch (error) {
        console.error("Error fetching activities:", error);
      }
    };
    fetchActivities();
  }, []);

  useEffect(() => {
    // Filter activities based on the search query
    setFilteredActivities(
      activities.filter((activity) =>
        activity.user.toLowerCase().includes(searchQuery.toLowerCase())
      )
    );
  }, [activities, searchQuery]);

  return (
    <Box className="activity-audit-page" sx={{ padding: 3 }}>
      <Typography variant="h4" gutterBottom>
        Activity Audit
      </Typography>
  
      {activities.length === 0 ? (
        <Typography>No activities found</Typography> // Show message if no activities
      ) : (
        <>
          <Box sx={{ display: "flex", alignItems: "center", marginBottom: 3 }}>
            <Input
              clearable
              bordered
              fullWidth
              labelPlaceholder="Search by User"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              size="lg"
            />
            <Spacer x={1} />
            <Button auto color="primary">
              Filter by Date
            </Button>
          </Box>
  
          <Table aria-label="Activity Log" css={{ height: "auto", minWidth: "100%" }}>
            <Table.Header>
              <Table.Column>User</Table.Column>
              <Table.Column>Action</Table.Column>
              <Table.Column>Timestamp</Table.Column>
              <Table.Column>Status</Table.Column>
            </Table.Header>
            <Table.Body>
              {filteredActivities.map((activity) => (
                <Table.Row key={activity.id}>
                  <Table.Cell>{activity.user}</Table.Cell>
                  <Table.Cell>{activity.action}</Table.Cell>
                  <Table.Cell>{new Date(activity.timestamp.seconds * 1000).toLocaleString()}</Table.Cell>
                  <Table.Cell>{activity.status}</Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </>
      )}
    </Box>
  );
};

export default ActivityAuditPage;